import { useUpdateTransactionalFootnote } from 'api-hooks/sale/mutation';
import {
  getTransactionalFootnoteKey,
  useGetTransactionableFootnote,
} from 'api-hooks/sale/query';
import { queryClient } from 'common/repositories/query-client';
import DrawerHeader from 'components/common/drawer/drawer-header';
import notification from 'components/common/notification';
import ErrorViewComponent from 'components/elements/error-view-component';
import FetchWrapperComponent from 'components/elements/fetch-wrapper-component';
import { DetailContainer } from 'legacy-modules/styles';
import useTranslation from 'next-translate/useTranslation';
import React from 'react';

import TransactionalFootnoteForm, {
  TransactionalFootnoteFormType,
} from './transactional-footnote-form';

interface TransactionalFootnoteFormProps {
  number: string;
  id: string;
  type?: 'sales' | 'purchases';
  onClose: () => void;
}

export default function TransactionalFootnoteDrawer(
  props: TransactionalFootnoteFormProps,
) {
  const { t } = useTranslation();
  const { id, number, type = 'sales', onClose } = props;

  const queryTransactionalFootnote = useGetTransactionableFootnote(type, {
    id,
  });

  const title = [t('common:note'), number].join(' - ');

  const mutateTransactionalFootnote = useUpdateTransactionalFootnote();

  const onSubmit = React.useCallback(
    (onClose: () => void) => async (input: TransactionalFootnoteFormType) => {
      const result = await mutateTransactionalFootnote.mutateAsync({
        body: input,
        id,
        type,
      });

      notification.success({
        message: `Update ${title} Successful`,
      });

      queryClient.refetchQueries(getTransactionalFootnoteKey({ id }));
      // onClose();

      return result.data;
    },
    [id, mutateTransactionalFootnote, title, type],
  );

  const transactional = queryTransactionalFootnote.data?.data;

  return (
    <>
      <DrawerHeader title={title} onClose={onClose} />
      <FetchWrapperComponent
        emptyText={queryTransactionalFootnote.error?.message}
        error={queryTransactionalFootnote.error}
        isLoading={
          queryTransactionalFootnote.isFetching ||
          queryTransactionalFootnote.isLoading
        }
        onRetry={queryTransactionalFootnote.refetch}
        errorComponent={
          <DetailContainer>
            <ErrorViewComponent refetch={queryTransactionalFootnote.refetch} />
          </DetailContainer>
        }
        component={
          <>
            {typeof transactional !== 'undefined' && (
              <TransactionalFootnoteForm
                onClose={onClose}
                onSubmit={onSubmit(onClose)}
                transactional={transactional}
              />
            )}
          </>
        }
      />
    </>
  );
}
